namespace TabAurous.OMS {
    export interface ServicesMasterRow {
        ServiceId?: number;
        ServiceCode?: string;
        ServiceName?: string;
        CategoryId?: number;
        TaxCode?: string;
        DefaultTdsType?: number;
    }

    export namespace ServicesMasterRow {
        export const idProperty = 'ServiceId';
        export const nameProperty = 'ServiceCode';
        export const localTextPrefix = 'OMS.ServicesMaster';
        export const deletePermission = 'Product:Category:Delete';
        export const insertPermission = 'Services:Add';
        export const readPermission = '*';
        export const updatePermission = 'Services:Edit';

        export declare const enum Fields {
            ServiceId = "ServiceId",
            ServiceCode = "ServiceCode",
            ServiceName = "ServiceName",
            CategoryId = "CategoryId",
            TaxCode = "TaxCode",
            DefaultTdsType = "DefaultTdsType"
        }
    }
}
